import * as React from 'react'
import AvailabilityDetails from '../../model/AvailabilityDetails'
import { Table } from 'react-bootstrap'
import { ToPercent, ToHours } from '../../common/Formatters'

export class AvailabilityTableBodyProps {
  details?: AvailabilityDetails
  message: string = ''
}

export class AvailabilityTableProps {
  siteDetails?: AvailabilityDetails
  siteMessage: string = ''
  generatorDetails?: AvailabilityDetails
  generatorMessage: string = ''
  generatorName: string = 'Generator'
}

export class AlarmDataCoverageTableBodyProps {
  siteDetails?: AvailabilityDetails
}

const GetColoredAlarmDataCoverage = (siteDetails: AvailabilityDetails | undefined) => {
  if (siteDetails && siteDetails.alarmDataCoverage) {
    const fontColor =
      (siteDetails.alarmDataCoverage === 1.0 ? 'text-success ' : 'text-warning ') +
      'font-weight-bold'
    return <p className={fontColor}>{ToPercent(siteDetails.alarmDataCoverage)}</p>
  } else {
    return <p className="text-danger font-weight-bold">Unknown</p>
  }
}

const AlarmDataCoverageTableBody = (props: AlarmDataCoverageTableBodyProps): JSX.Element => (
  <tr>
    <th scope="row">Alarm Data Coverage</th>
    <td>{GetColoredAlarmDataCoverage(props.siteDetails)}</td>
  </tr>
)

const AvailabilityTableBody = (props: AvailabilityTableBodyProps): JSX.Element =>
  props.details ? (
    <tbody>
      <tr>
        <td rowSpan={2}>{props.details.name}</td>
        <td>Availability (%)</td>
        <td>{ToPercent(props.details.contractualAvailability)}</td>
        <td>{ToPercent(props.details.budgetedGeneratorAvailability)}</td>
        <td>{ToPercent(props.details.budgetedSiteAvailability)}</td>
        <td>{ToPercent(props.details.actualGeneratorAvailability)}</td>
        <td>{ToPercent(props.details.actualSiteAvailability)}</td>
        <td>{ToPercent(props.details.operationalAvailability)}</td>
      </tr>
      <tr>
        <td>Downtime (Hours)</td>
        <td>{ToHours(props.details.contractualDowntimeHours)}</td>
        <td>{ToHours(props.details.budgetedGeneratorDowntimeHours)}</td>
        <td>{ToHours(props.details.budgetedSiteDowntimeHours)}</td>
        <td>{ToHours(props.details.generatorDowntimeHours)}</td>
        <td>{ToHours(props.details.siteDowntimeHours)}</td>
        <td>{ToHours(props.details.operationalDowntimeHours)}</td>
      </tr>
    </tbody>
  ) : (
    <tbody>
      <tr>
        <td colSpan={8}>{props.message}</td>
      </tr>
    </tbody>
  )

export const AvailabilityTable = (props: AvailabilityTableProps): JSX.Element => (
  <Table className="availability-table">
    <colgroup>
      <col className="title" span={2} />
      <col className="contractual" />
      <col className="budget" span={2} />
      <col className="actual" span={3} />
    </colgroup>
    <thead>
      <tr>
        <th rowSpan={2} colSpan={2}></th>
        <th rowSpan={2}>Contractual</th>
        <th className="merged" colSpan={2}>
          Budget
        </th>
        <th className="merged" colSpan={3}>
          Actual
        </th>
      </tr>
      <tr>
        <th>{props.generatorName}</th>
        <th>Site</th>
        <th>{props.generatorName}</th>
        <th>Site</th>
        <th>Operational</th>
      </tr>
    </thead>
    <AvailabilityTableBody details={props.generatorDetails} message={props.generatorMessage} />
    <AvailabilityTableBody details={props.siteDetails} message={props.siteMessage} />
    <AlarmDataCoverageTableBody siteDetails={props.siteDetails} />
  </Table>
)
